import { render, staticRenderFns } from "./addOrEditVideo.vue?vue&type=template&id=052b4bbc"
import script from "./addOrEditVideo.vue?vue&type=script&lang=js"
export * from "./addOrEditVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports